import "core-js/modules/es6.object.keys";
import "core-js/modules/web.dom.iterable";
import "core-js/modules/es6.array.find-index";
import "core-js/modules/es7.array.includes";
import "core-js/modules/es6.string.includes";
import "core-js/modules/es6.regexp.replace";
import "core-js/modules/es6.regexp.split";
import _slicedToArray from "D:/webproject/haoyu/wms-web/WMS/node_modules/@babel/runtime/helpers/esm/slicedToArray.js";
import "core-js/modules/es6.number.constructor";
import "core-js/modules/es6.number.is-nan";
import Big from "big.js";
import Vue from 'vue';

/**
 * 金额转中文
 * 思路：
 * 个 十   百   千   万
 *    十万 百万 千万 亿
 *    十亿 百亿 千亿
 * 1  2    3    4    5
 *    6    7    8    9
 *    10
 *
 */
export function getAmountChinese(val) {
  var amount = +val;
  if (Number.isNaN(amount) || amount < 0) return "";
  var NUMBER = ["零", "壹", "贰", "叁", "肆", "伍", "陆", "柒", "捌", "玖"];
  var N_UNIT1 = ["", "拾", "佰", "仟"];
  var N_UNIT2 = ["", "万", "亿"];
  var D_UNIT = ["角", "分"];
  var _amount$toFixed$split = amount.toFixed(2).split("."),
    _amount$toFixed$split2 = _slicedToArray(_amount$toFixed$split, 2),
    integer = _amount$toFixed$split2[0],
    decimal = _amount$toFixed$split2[1];
  if (integer && integer.length > 12) return "金额过大无法计算";
  var res = "";
  // 整数部分
  if (integer) {
    for (var i = 0, len = integer.length; i < len; i++) {
      var num = integer.charAt(i);
      var pos = len - i - 1; // -1 排除个位干扰
      if (i === len - 1 && num === "0") break;
      res += NUMBER[num] + N_UNIT1[pos % 4];
      if (pos % 4 === 0) {
        // 排除个位数后 万和亿位置都是4的倍数
        res += N_UNIT2[Math.floor(pos / 4)];
      }
    }
  }
  res += "圆";
  if (decimal) {
    // 小数部分
    for (var _i = 0; _i < 2; _i++) {
      var _num = decimal.charAt(_i);
      _num !== "0" && (res += NUMBER[_num] + D_UNIT[_i]);
    }
  }
  return res;
}

/**
 * 计算两个时间差经历的时间的文字描述
 * @param {*} timestamp - 毫秒
 */
export var timeCalculate = function timeCalculate(start, end) {
  var label = ["分钟", "小时", "天", "月", "年"];
  var unit = [60, 60, 24, 30, 12];
  var restTime = Math.floor((end - start) / 1000);
  var res = "";
  for (var i = 0, len = unit.length; i < len; i++) {
    var pos = len - i; // 从年开始算，分钟换算成年 === Math.pow(60, 4)
    var temp = unit.slice(0, pos).reduce(function (p, c) {
      return p * c;
    }, 1);
    var time = Math.floor(restTime / temp);
    time > 0 && (res += time + label[pos - 1]);
    restTime -= time * temp;
  }
  return res;
};

/**
 * 简易防抖函数
 * @param {Function} func -防抖目标函数
 * @param {Number}} gap - 防抖时间间隔
 */
export var debounce = function debounce(func, gap) {
  var timer;
  return function () {
    var _arguments = arguments,
      _this = this;
    timer && clearTimeout(timer);
    timer = setTimeout(function () {
      func.apply(_this, _arguments);
    }, gap);
  };
};
/**
 * 下划线转驼峰
 * @param {String} name - 字符串
 */
export var toHump = function toHump(name) {
  return name.replace(/\_(\w)/g, function (all, letter) {
    return letter.toUpperCase();
  });
};
/**
 * 将用户输入的连续单个数字合并为一个数
 * @param {Array} expressions - 记录计算表达式的数组
 * @returns {Array} 新的数组
 */
export var mergeNumberOfExps = function mergeNumberOfExps(expressions) {
  var res = [];
  var isNumChar = function isNumChar(n) {
    return /^[\d|\.]$/.test(n);
  };
  for (var i = 0; i < expressions.length; i++) {
    if (i > 0 && isNumChar(expressions[i - 1]) && isNumChar(expressions[i])) {
      res[res.length - 1] += expressions[i];
      continue;
    }
    res.push(expressions[i]);
  }
  return res;
};
/**
 * 校验表达式是否符合计算法则
 * @param {Array} expressions - 合并数字后的表达式数组
 * @returns {Boolean}
 */
export var validExp = function validExp(expressions) {
  var mergeNum = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : true;
  var temp = mergeNum ? mergeNumberOfExps(expressions) : expressions;
  var arr = temp.filter(function (t) {
    return !"()".includes(t);
  });
  // 去括号后 length应该为奇数  并且第一个字符和最后一个字符应该为数字而非计算符号
  if (temp.length % 2 === 0 || arr.length % 2 === 0 || Number.isNaN(+arr[0]) || Number.isNaN(+arr[arr.length - 1])) {
    return false;
  }
  for (var i = 0; i < arr.length - 1; i += 2) {
    if (typeof +arr[i] !== "number" || !Number.isNaN(+arr[i + 1])) return false;
  }
  return true;
};

/**
 * 中缀转后缀（逆波兰 Reverse Polish Notation）
 * @param {Array} exps - 中缀表达式数组
 */
export var toRPN = function toRPN(exps) {
  var s1 = []; // 符号栈
  var s2 = []; // 输出栈
  var getTopVal = function getTopVal(stack) {
    return stack.length > 0 ? stack[stack.length - 1] : null;
  };
  var levelCompare = function levelCompare(c1, c2) {
    var getIndex = function getIndex(c) {
      return ["+-", "×÷", "()"].findIndex(function (t) {
        return t.includes(c);
      });
    };
    return getIndex(c1) - getIndex(c2);
  };
  exps.forEach(function (t) {
    if (typeof t === "string" && Number.isNaN(Number(t))) {
      // 是符号
      if (t === "(") {
        s1.push(t);
      } else if (t === ")") {
        var popVal;
        do {
          popVal = s1.pop();
          popVal !== "(" && s2.push(popVal);
        } while (s1.length && popVal !== "(");
      } else {
        var topVal = getTopVal(s1);
        if (!topVal) {
          // s1 为空 直接push
          s1.push(t);
        } else {
          while (topVal && topVal !== "(" && levelCompare(topVal, t) >= 0) {
            // 优先级 >= t 弹出到s2
            s2.push(s1.pop());
            topVal = getTopVal(s1);
          }
          s1.push(t);
        }
      }
      return;
    }
    s2.push(t); // 数字直接入栈
  });

  while (s1.length) {
    s2.push(s1.pop());
  }
  return s2;
};
/**
 * 计算后缀表达式的值
 * @param {Array} rpnExps - 后缀表达式
 */
export var calcRPN = function calcRPN(rpnExps) {
  rpnExps = rpnExps.concat();
  var calc = function calc(x, y, type) {
    var a1 = Number(x),
      a2 = Number(y);
    switch (type) {
      case "+":
        return a1 + a2;
      case "-":
        return a1 - a2;
      case "×":
        return a1 * a2;
      case "÷":
        return a1 / a2;
    }
  };
  for (var i = 2; i < rpnExps.length; i++) {
    if ("+-×÷".includes(rpnExps[i])) {
      var val = calc(rpnExps[i - 2], rpnExps[i - 1], rpnExps[i]);
      rpnExps.splice(i - 2, 3, val);
      i = i - 2;
    }
  }
  return rpnExps[0];
};
function delHtmlTag(str) {
  return str.replace(/<[^>]+>/g, "");
}
function rejectnbsp(value) {
  var value = String(value);
  if (value.indexOf("nbsp") != -1) {
    value = value.replace(/&nbsp;/gi, "");
  }
  return value;
}
/**去除富文本表情空格，计算控制字数 */
/**
 * 加法精度计算函数
 * @param arg1 参数1
 * @param arg2 参数2
 */
export function accAdd(arg1, arg2) {
  var x = new Big(arg1);
  return Number(x.plus(arg2).valueOf());
}
/**
 * 减法精度计算函数
 * @param arg1 参数1
 * @param arg2 参数2
 */
export function accSub(arg1, arg2) {
  var x = new Big(arg1);
  return Number(x.minus(arg2).valueOf());
}
/**
 * 乘法精度计算函数
 * @param arg1 参数1
 * @param arg2 参数2
 */
export function accMul(arg1, arg2) {
  var x = new Big(arg1);
  return Number(x.mul(arg2).valueOf());
}
/**
 * 除法精度计算函数
 * @param arg1 参数1
 * @param arg2 参数2
 */
export function accDiv(arg1, arg2) {
  var x = new Big(arg1);
  return Number(x.div(arg2).valueOf());
}
export function lift(arg1, arg2) {
  return accDiv(accSub(arg2, arg1), arg1 === 0 ? 1 : arg1);
}
export function trimHtml(content) {
  return rejectnbsp(delHtmlTag(content)).trim();
}

/**
 *
 * @param {*} url
 * @param {*} options  {w: 100, h: 100}
 */
export function picFilter(url) {
  var options = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
  // console.log(url)
  if (url && url.indexOf('http') !== -1) {
    return url;
  } else {
    return getPic(url, options);
  }
}
function getPic(url, options) {
  // let picOptions = ''
  var urlPath = url;
  var optionsPath = '';
  var prePicPath = Vue.prototype.imgPrefix;
  var optionList = Object.keys(options).filter(function (ele) {
    return ele !== 'size';
  });
  if (!urlPath) {
    if (options.size === 'large') {
      urlPath = '63aa31c561f64ccba25dd71e7af062e2.png';
    } else {
      urlPath = 'b52a30ff97534c38bf0d327b9a9065ab.png';
    }
  }
  if (optionList.length) {
    optionsPath = '?x-oss-process=image/resize';
    optionList.forEach(function (key) {
      optionsPath += ",".concat(key, "_").concat(options[key]);
    });
  }
  return "".concat(prePicPath).concat(urlPath).concat(optionsPath);
}